<div class=" o-modal--medium" id="mod-qual" style="width: 100%;">
    <div class="o-modal__head ">
        <a class="o-modal__close close-modal" style="cursor: pointer;" matDialogClose></a>
        <label class="o-title o-title--white o-title--medium">{{'EmployeeQualificationPortal.title' | translate}}</label>
    </div>
    <div class="o-modal__body">
        <div class="o-modal__text">
            <ul class="o-modal__qualifications">




                <div *ngIf="data.length>0">
                    <li *ngFor=" let qualification of data">
                        <i *ngIf="qualification.status===2" class="icon icon-close"></i>
                        <i *ngIf="qualification.status===0" class="icon icon-check"></i>
                        <i *ngIf="qualification.status===1" class="icon icon-arrow" style=" transform: rotateY(180deg);"></i>
                        <p class="u-mb0"> {{qualification.name}}</p>
                        <p class="u-mb0" *ngIf="qualification.mandatory && qualification.status==2" style="color: red;">{{'EmployeeQualificationPortal.mandatory' | translate}}</p>
                        <p class="u-mb10" *ngIf="qualification.status===2">{{'EmployeeQualificationPortal.labelExpires' | translate}} {{qualification.expirationDate | date: 'dd/MM/yyyy'}}</p>
                        <p class="u-mb10" *ngIf="qualification.status===1">{{'EmployeeQualificationPortal.willExpire'|translate}} {{qualification.expirationDate | date: 'dd/MM/yyyy'}}</p>

                        <!-- <h6> fault expiration </h6>-->
                    </li>
                </div>
                <div *ngIf="data.length===0">
                    <h3> {{'EmployeeQualificationPortal.noObs' | translate}}</h3>
                </div>
                <!--<li> <i class="icon icon-check icon--warning"></i>-->

            </ul>
        </div>
    </div>
</div>